import { defineMessages, FormattedMessage, useIntl } from 'dibs-react-intl';
import formStyles from './styles/FormGeneral.scss';
import stepContactsStyles from './styles/FormStepContacts.scss';
import { WrappedInput } from './fields/WrappedInput.jsx';
import { MatchmakerButton } from './fields/MatchmakerButton.jsx';
import { MatchmakerInput } from './fields/MatchmakerInput.jsx';
import { LastElement } from './fields/LastElement.jsx';
import { Budget } from './select/Budget.jsx';
import { CountryDropdownRenderer } from './select/CountryDropdownRenderer.jsx';
import { BackButton } from './BackButton.jsx';
import { TextArea } from 'dibs-elements/exports/TextArea.tsx';
const messages = defineMessages({
    additionalInfoPlaceholder: {
        id: 'abt.matchmaker.formReview.additionalInfoPlaceholder',
        defaultMessage: 'Enter additional project details you would like to share.',
    },
});
const placeholder = defineMessages({
    postalCode: {
        id: 'abt.matchmaker.formStepContacts.postalCodePlaceholder',
        defaultMessage: 'Postal code',
    },
    phone: {
        id: 'abt.matchmaker.formStepContacts.phonePlaceholder',
        defaultMessage: 'Phone number',
    },
    email: {
        id: 'abt.matchmaker.formStepContacts.emailPlaceholder',
        defaultMessage: 'Email address',
    },
});
export const FormStepContacts = props => {
    const intl = useIntl();
    return (
        <>
            <div className={formStyles.contentWrapper}>
                <WrappedInput
                    label={
                        <FormattedMessage
                            id="abt.matchmaker.formStepContacts.locationInput"
                            defaultMessage="Location"
                        />
                    }
                    input={
                        <MatchmakerInput
                            marginRight
                            value={props.postalCode}
                            onChange={props.onChangePostalCode}
                            placeholder={placeholder.postalCode}
                            errorMessage={props.errors.postalCode || ''}
                        />
                    }
                    secondInput={
                        <CountryDropdownRenderer
                            value={props.country}
                            onChange={props.onChangeCountry}
                            errorMessage={props.errors.country || ''}
                        />
                    }
                />
                <WrappedInput
                    label={
                        <FormattedMessage
                            id="abt.matchmaker.formStepContacts.budgetInput"
                            defaultMessage="Budget"
                        />
                    }
                    input={
                        <Budget
                            value={props.budget}
                            onChange={props.onChangeBudget}
                            errorMessage={props.errors.budget || ''}
                        />
                    }
                />
                <div className={formStyles.divider} />
                <WrappedInput
                    label={
                        <FormattedMessage
                            id="abt.matchmaker.formStepContacts.contactInput"
                            defaultMessage="Your Contact Information"
                        />
                    }
                    input={
                        !props.userId ? (
                            <MatchmakerInput
                                value={props.email}
                                placeholder={placeholder.email}
                                onChange={props.onChangeEmail}
                                errorMessage={props.errors.email || ''}
                            />
                        ) : (
                            <MatchmakerInput
                                value={props.phone}
                                placeholder={placeholder.phone}
                                onChange={props.onChangePhone}
                                errorMessage={props.errors.phone || ''}
                            />
                        )
                    }
                    secondInput={
                        !props.userId ? (
                            <MatchmakerInput
                                value={props.phone}
                                placeholder={placeholder.phone}
                                onChange={props.onChangePhone}
                                errorMessage={props.errors.phone || ''}
                            />
                        ) : null
                    }
                    subText={
                        <div className={stepContactsStyles.privacyText}>
                            {!props.userId ? (
                                <FormattedMessage
                                    id="abt.matchmaker.formStepContacts.privacyTextNotLoggedIn"
                                    defaultMessage="When receiving your request, our concierge team will schedcule a phone call to share our initial recommendations and learn more about your project."
                                />
                            ) : (
                                <FormattedMessage
                                    id="abt.matchmaker.formStepContacts.privacyTextLoggedIn"
                                    defaultMessage="We will not share your contact information with any designers."
                                />
                            )}
                        </div>
                    }
                />
                <WrappedInput
                    label={
                        <FormattedMessage
                            id="abt.matchmaker.formStepContacts.tellUsMore"
                            defaultMessage="Include a message (optional)"
                        />
                    }
                    input={
                        <TextArea
                            name="tellUsMore"
                            dataTn="matchmaker-input-tellUsMore"
                            onChange={props.onChangeMore}
                            placeholder={intl.formatMessage(messages.additionalInfoPlaceholder)}
                            value={props.tellUsMore}
                        />
                    }
                />
            </div>
            <div className={stepContactsStyles.contactTextWrapper}>
                <div className={formStyles.divider} />
                <div className={stepContactsStyles.bottomText}>
                    <FormattedMessage
                        id="abt.matchmaker.formSteepContacts.bottomText"
                        defaultMessage="A member of our concierge team will reach out within 4 to 5 business days with a curated list of designers that match your needs."
                    />
                </div>
            </div>
            <div className={formStyles.contentWrapper}>
                <MatchmakerButton
                    style={stepContactsStyles.ctaNext}
                    onClick={props.onPageChange}
                    buttonName={
                        <FormattedMessage
                            id="abt.matchmaker.formStepContacts.sendInformationButton"
                            defaultMessage="Send Information"
                        />
                    }
                />
                <LastElement child={<BackButton onClick={props.onPageBack} />} />
            </div>
        </>
    );
};
